import React, {useState} from 'react'
import {MdSort} from 'react-icons/md'
import useWidth from '@hooks/useWidth'
import Filters from '@page-components/Order/Products/ProductsContent/Filters'
import classnames from 'classnames'
import {useTranslation} from 'next-i18next'

import ProductFilters from '../ProductFilters'

import GoBack from './GoBack'
import MobileCategoriesMenu from './MobileCategoriesMenu'

import contentStyles from '../styles.module.css'
import backStyles from './GoBack/styles.module.css'
import localStyles from './styles.module.css'

const styles = {...contentStyles, ...backStyles, ...localStyles}

export default function TopRow({category, order, setOrder}) {
  const width = useWidth()
  const isMobile = width <= 768
  const [open, setOpen] = useState(false)
  const [openFilters, setOpenFilters] = useState(false)
  const {t} = useTranslation('website', {keyPrefix: 'order.products.productsContent.filters'})

  return isMobile ? (
    <div>
      {openFilters && <ProductFilters setOpenFilters={setOpenFilters} />}
      {open && <MobileCategoriesMenu setOpen={setOpen} />}
      <div className={styles.titleContainer}>
        <h1 className={styles.categoryName}>{category.name}</h1>
        <GoBack category={category} />
      </div>
      <div className={classnames(styles.inner, styles.actions)}>
        <span className={styles.containerFilter}>
          <MdSort />
          <span onClick={() => setOpenFilters(true)} className={styles.spaceLeft}>
            {t('labelShowFilters')}
          </span>
        </span>
        <span className={styles.textWithIcon}>
          <span className={styles.spaceLeft}>
            <Filters
              sorting={order}
              setSorting={setOrder}
              additionalClassname={styles.orderSelector}
            />
          </span>
        </span>
      </div>
    </div>
  ) : (
    <div className={styles.inner}>
      <div className={styles.leftWrap}>
        <div />
      </div>
      <div className={styles.rightWrap}>
        <h1 className={styles.categoryName}>{category.name}</h1>
        <Filters sorting={order} setSorting={setOrder} additionalClassname={styles.orderSelector} />
      </div>
    </div>
  )
}
